<template>
    <div class="addvalue">
        <div class="content_01" :style="'background:url('+indata.showImage1+') no-repeat 50% 50%'" ></div>
        <div class="content_02" :style="'background:url('+indata.showImage2+') no-repeat 50% 50%'" ></div>
        <div class="content_04" :style="'background:url('+indata.showImage3+') no-repeat 50% 50%'" ></div>
        <div class="content_06" :style="'background:url('+indata.showImage4+') no-repeat 50% 50%'" ></div>
    </div>
</template>
<style scoped src="../../public/css/icould.css">
</style>

<script>
export default {
  name: "Templates27",
  props:{
    indata:Array
  },
  data(){
    return{
      NowIndex:0
    }
  }
  ,
  methods :{
changeActive(index){
  this.NowIndex=index
}
  }
};
</script>
